export default function Contact() {
  return (
    <div data-testid="contact-page" className="max-w-3xl mx-auto px-6 md:px-12 py-20">
      <p className="font-hand text-2xl text-[#A3876A] mb-4">Écrivons-nous</p>
      <h1 className="font-serif text-5xl md:text-6xl mb-8">Contact</h1>
      <p className="text-[#4A4036] mb-10 text-lg">Une question, une envie, un projet à deux ? Écris-moi directement — je te réponds sous quelques jours.</p>
      <div className="bg-[#F7F1E7] border border-[#E8DCC8] rounded-2xl px-8 py-10 text-center">
        <p className="font-hand text-xl text-[#A3876A] mb-3">Mon adresse</p>
        <a
          data-testid="contact-mailto"
          href="mailto:amelie@lesrdvdelecriture.com"
          className="font-serif text-2xl md:text-3xl text-[#4A4036] underline underline-offset-8 decoration-[#A3876A] hover:text-[#A3876A] transition-colors"
        >
          amelie@lesrdvdelecriture.com
        </a>
      </div>
    </div>
  );
}
